export default {
  layout_types: [
    {
      value: 1,
      label: "tables",
    },
    {
      value: 2,
      label: "orders",
    },
  ],
  sort_options: [
    {
      value: 1,
      label: "Date",
    },
    {
      value: 2,
      label: "tables",
    },
    {
      value: 3,
      label: "status",
    },
  ],
};
